module.exports = __webpack_public_path__ + "img/ترکیبی.635ce3bf.png";